import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default class ScroolingPromoFeature {
  constructor(elem, APP) {
    this.elem = elem;
    this.slides = this.elem.querySelectorAll(".js-spf-slide");
    this.slideTLs = [];
    this.slideOutTLs = [];
    this.direction = false;

    gsap.registerPlugin(ScrollTrigger);
  }

  scrollSlides() {
    // slide animation
    // this.slides.forEach((slide, index) => {
    //   const slideAni = gsap.timeline();
    //   const num = index + 1;

    //   slideAni.to(`.js-spf-heading-${num}`, {opacity: 1, bottom:0, duration:1,  ease: "power2.out"}, 0);
    //   slideAni.to(`.js-spf-desc-${num}`, {opacity: 1, top: 0, duration:0.3}, 0.5);

    //   let time = 0.5 + 0.2;
    //   if(slide.querySelector('.spf-stats')) {
    //     slideAni.to(`.js-spf-stats-${num}`, { opacity: 1, top: 0, duration: 0.3 }, time);
    //     time = time + 0.2;
    //   }

    //   if(slide.querySelector('.spf-cta')) {
    //     slideAni.to(`.js-spf-cta-${num}`, { opacity: 1, top: 0, duration: 0.3 }, time);
    //   }

    //   slideAni.pause(0);

    //   this.slideTLs.push(slideAni);
    // });

    const mainTL = gsap.timeline({
      scrollTrigger: {
        trigger: this.elem,
        start: "top top",
        end: "+=3000",
        pin: true,
        scrub: 1.5,
        toggleActions: "play none none reset",
        onUpdate: ({progress, direction, isActive}) => {
          // console.log("progress:", progress, "direction:", direction, "isActive", isActive);
          this.direction = direction;
        }
      }
    });

    const secondaryTL  = gsap.timeline({
      scrollTrigger: {
        trigger: this.elem,
        start: "top bottom",
        scrub: 1.5,
        onEnter: ({progress, direction, isActive}) => {
          // reset
          this.slideTLs.forEach((ani) => {
            ani.reverse(0);
          })
        }
      }
    });

    // intro
    secondaryTL.to('.js-spf-img-1', {top: 0, duration: 0.7});

    // main
    // slide 1
    let mainTime = 0;
    mainTL.to(`.js-spf-img-1`, { filter: "grayscale(100%)", duration: 0.5 }, 0);
    mainTL.to(`.js-spf-slide-dot-1`, { backgroundColor: '#2DEDEA', duration: 0 }, 0);
    mainTL.to(`.js-spf-slide-dot-2`, { backgroundColor: 'transparent', duration: 0 }, 0);
    mainTL.to(`.js-spf-slide-dot-3`, { backgroundColor: 'transparent', duration: 0 }, 0);
    // mainTL.to(`.js-spf-container-1`, { opacity: 1, duration: 0.2 }, 0.3);
    mainTL.to(`.js-spf-tint-1`, { opacity: 1, scale: 1, duration: 0.5 }, 0.5);
    mainTL.to(`.js-spf-heading-1`, { opacity: 1, bottom: 0, duration: 0.5 }, 0.9);
    mainTL.to(`.js-spf-desc-1`, { opacity: 1, duration: 0.3, delay: 0.5 }, 0.9);
    if(this.elem.querySelector('.js-spf-stats-1')) {
      mainTL.to(`.js-spf-stats-1`, { opacity: 1, duration: 0.3, delay: 0.7 }, 0.9);
      mainTL.to(`.js-spf-cta-1`, { opacity: 1, duration: 0.2, delay: 0.8 }, 0.9);
    }else{
      mainTL.to(`.js-spf-cta-1`, { opacity: 1, duration: 0.2, delay: 0.6 }, 0.9);
    }
    // mainTL.to(`.js-spf-slide-1`, {  duration: 1, onStart: () => {
    //   if(this.direction)this.slideTLs[0].play()
    //   else this.slideTLs[0].reverse();
    // } }, 1);
    mainTL.to(`.js-spf-slide-1`, { top: '-100vh', duration: 2 }, 2); // outro

    // slide 2
    mainTime = 2;
    mainTL.to(`.js-spf-slide-2`, { top: 0, duration: 2 }, mainTime);
    mainTL.to(`.js-spf-slide-dot-1`, { backgroundColor: 'transparent', duration: 0 }, mainTime+1.5);
    mainTL.to(`.js-spf-slide-dot-2`, { backgroundColor: '#2DEDEA', duration: 0 }, mainTime+1.5);
    mainTL.to(`.js-spf-slide-dot-3`, { backgroundColor: 'transparent', duration: 0 }, mainTime+1.5);
    mainTL.to(`.js-spf-img-2`, { top: 0, duration: 2 }, mainTime);
    mainTL.to(`.js-spf-img-2`, { filter: "grayscale(100%)", duration: 0.5, delay: 1.5 }, mainTime);
    // mainTL.to(`.js-spf-container-2`, { opacity: 1, duration: 0.2 }, mainTime+1.8);
    mainTL.to(`.js-spf-tint-2`, { opacity: 1, scale: 1, duration: 0.5 }, mainTime+2);
    mainTL.to(`.js-spf-heading-2`, { opacity: 1, bottom: 0, duration: 0.5 }, mainTime+2.4);
    mainTL.to(`.js-spf-desc-2`, { opacity: 1, duration: 0.3, delay: 0.5 }, mainTime+2.4);
    if(this.elem.querySelector('.js-spf-stats-2')) {
      mainTL.to(`.js-spf-stats-2`, { opacity: 1, duration: 0.3, delay: 0.7 }, mainTime+2.4);
      mainTL.to(`.js-spf-cta-2`, { opacity: 1, duration: 0.2, delay: 0.8 }, mainTime+2.4);
    } else {
      mainTL.to(`.js-spf-cta-2`, { opacity: 1, duration: 0.2, delay: 0.6 }, mainTime+2.4);
    }
    // mainTL.to(`.js-spf-slide-2`, {  duration: 1, onStart: () => {
    //   this.slideTLs[1].play();
    // } }, mainTime+2.5);
    mainTL.to(`.js-spf-slide-2`, { top: '-100vh', duration: 2 }, mainTime+3.5);

    //
    mainTime = 5.5;
    mainTL.to(`.js-spf-slide-3`, { top: 0, duration: 2 }, mainTime);
    mainTL.to(`.js-spf-slide-dot-1`, { backgroundColor: 'transparent', duration: 0 }, mainTime+1.5);
    mainTL.to(`.js-spf-slide-dot-2`, { backgroundColor: 'transparent', duration: 0 }, mainTime+1.5);
    mainTL.to(`.js-spf-slide-dot-3`, { backgroundColor: '#2DEDEA', duration: 0 }, mainTime+1.5);
    mainTL.to(`.js-spf-img-3`, { top: 0, duration: 2 }, mainTime);
    mainTL.to(`.js-spf-img-3`, { filter: "grayscale(100%)", duration: 0.5, delay: 1.5 }, mainTime);
    // mainTL.to(`.js-spf-container-3`, { opacity: 1, duration: 0.2 }, mainTime+1.8);
    mainTL.to(`.js-spf-tint-3`, { opacity: 1, scale: 1, duration: 0.5 }, mainTime+2);
    mainTL.to(`.js-spf-heading-3`, { opacity: 1, bottom: 0, duration: 0.5 }, mainTime+2.4);
    mainTL.to(`.js-spf-desc-3`, { opacity: 1, duration: 0.3, delay: 0.5 }, mainTime+2.4);
    if(this.elem.querySelector('.js-spf-stats-3')) {
      mainTL.to(`.js-spf-stats-3`, { opacity: 1, duration: 0.3, delay: 0.7 }, mainTime+2.4);
      mainTL.to(`.js-spf-cta-3`, { opacity: 1, duration: 0.2, delay: 0.8 }, mainTime+2.4);
    } else {
      mainTL.to(`.js-spf-cta-3`, { opacity: 1, duration: 0.2, delay: 0.6 }, mainTime+2.4);
    }
    // mainTL.to(`.js-spf-slide-3`, {  duration: 1, onStart: () => {
    //   this.slideTLs[2].play();
    // } }, mainTime+2.5);

    // end of animation
    mainTL.to(`.js-spf-slide-3`, {  duration: 1 }, mainTime+3.5);
  }

  init() {

    this.scrollSlides();
  }
}
